import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actions from '../../actions/BlogActions'

class ModalView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            description: [''],
            img: '',
            author: ''
        }
    }

    componentDidMount() {
        if (this.props.blog) {
            this.setState({
                title: this.props.blog.title,
                description: this.props.blog.description,
                img: this.props.blog.img,
                author: this.props.blog.author
            })
        }
    }

    closeModal = () => {
        this.props.hideModal();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleChangeDesc = (e, index) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.description[index] = e.target.value;
        this.setState({
            description: this.state.description
        })
    }


    handleRemoveClick = (index) => {
        this.state.description.splice(index, 1);
        this.setState({
            description: this.state.description
        })
    }

    handleAddClick = () => {
        this.setState({
            description: [...this.state.description, ""]
        })
    }


    handleClearFrom = () => {
        this.setState({
            title: '',
            description: '',
            img: '',
            author: ''
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        var { title, description, img, author } = this.state;
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var date = dd + "/" + mm + "/" + yyyy;
        if (author === "") {
            alert("Mời nhập họ tên")
        } else if (title === "") {
            alert("Mời nhập tiêu đề blog")
        } else if (img === "") {
            alert("Mời nhập đường dẫn ảnh")
        } else if (description === "") {
            alert("Mời nhập nội dung blog")
        } else {
            this.props.addBlog({
                title: title,
                description: description,
                img: img,
                createDate: date,
                author: author
            });
            alert("Thêm blog thành công !")
            this.handleClearFrom();
            this.closeModal();
            window.scrollTo({
                top: document.body.scrollHeight,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    handleEditBlog = (e) => {
        e.preventDefault();
        var { title, description, img, author } = this.state;
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var date = dd + "/" + mm + "/" + yyyy;
        if (author === "") {
            alert("Mời nhập họ tên")
        } else if (title === "") {
            alert("Mời nhập tiêu đề blog")
        } else if (img === "") {
            alert("Mời nhập đường dẫn ảnh")
        } else if (description === "") {
            alert("Mời nhập nội dung blog")
        } else {
            this.props.editBlog({
                id: this.props.blog.id,
                title: title,
                description: description,
                img: img,
                createDate: date,
                author: author
            });
            alert("Sửa blog thành công !")
            this.handleClearFrom();
            this.closeModal();
        }
    }

    render() {
        var { blog } = this.props;
        var { title, img, author } = this.state
        if (blog) {
            return (
                <>
                    <Modal.Header>
                        <Modal.Title>
                            Edit Blog
                        </Modal.Title>
                        <button
                            type="button"
                            className="close-header"
                            onClick={this.closeModal}
                        >
                            <i className="fa fa-times mr-3"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form">
                            <input name="form_type" type="hidden" defaultValue="contact" />
                            <div className="form-group">
                                <label htmlFor="contactFormAuthor" className="sr-only">
                                    Họ tên
                                </label>
                                <input
                                    required
                                    type="text"
                                    id="contactFormAuthor"
                                    className="form-control input-lg"
                                    name="author"
                                    placeholder="Author"
                                    autoCapitalize="words"
                                    value={author}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="contactFormName" className="sr-only">
                                    Tiêu đề
                                </label>
                                <input
                                    required
                                    type="text"
                                    id="contactFormName"
                                    className="form-control input-lg"
                                    name="title"
                                    placeholder="Title"
                                    autoCapitalize="words"
                                    value={title}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="contactFormEmail" className="sr-only">
                                    Hình ảnh
                                </label>
                                <input
                                    required
                                    type="text"
                                    name="img"
                                    placeholder="Url image (hơi cùi ạ :v)"
                                    id="contactFormEmail"
                                    className="form-control input-lg"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    value={img}
                                    onChange={this.handleChange}
                                />
                            </div>
                            {
                                this.state.description ? this.state.description.map((item, index) => {
                                    return (
                                        <div className="form-group form-content" key={index}>
                                            <label htmlFor="contactFormMessage" className="sr-only">Nội dung {index + 1}</label>
                                            <textarea
                                                required
                                                rows={3}
                                                name="content"
                                                className="form-control"
                                                placeholder="Content"
                                                id="contactFormMessage"
                                                value={item}
                                                onChange={(e) => this.handleChangeDesc(e, index)}
                                            />
                                            <button
                                                className="btn btn-warning btn-remove"
                                                onClick={() => this.handleRemoveClick(index)}
                                            >Xoá</button>
                                        </div>
                                    )
                                }) : ['']
                            }<button
                                className="btn btn-info mt-2 mb-3 btn-add-blog"
                                onClick={() => this.handleAddClick()}
                            >Thêm nội dung</button>
                            <button
                                className="btn btn-primary btn-lg btn-rb mr-3"
                                onClick={this.handleEditBlog}
                            >
                                Sửa blog
                            </button>
                            <button
                                className="btn btn-outline-secondary btn-lg"
                                onClick={this.closeModal}
                            >Huỷ</button>
                        </div>
                    </Modal.Body>
                </>
            );
        } else {
            return (
                <>
                    <Modal.Header>
                        <Modal.Title>
                            Add Blog
                        </Modal.Title>
                        <button
                            type="button"
                            className="close-header"
                            onClick={this.closeModal}
                        >
                            <i className="fa fa-times mr-3"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form">
                            <input name="form_type" type="hidden" defaultValue="contact" />
                            <div className="form-group">
                                <label htmlFor="contactFormAuthor" className="sr-only">
                                    Họ tên
                                </label>
                                <input
                                    required
                                    type="text"
                                    id="contactFormAuthor"
                                    className="form-control input-lg"
                                    name="author"
                                    placeholder="Author"
                                    autoCapitalize="words"
                                    value={author}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="contactFormName" className="sr-only">
                                    Tiêu đề
                                </label>
                                <input
                                    required
                                    type="text"
                                    id="contactFormName"
                                    className="form-control input-lg"
                                    name="title"
                                    placeholder="Title"
                                    autoCapitalize="words"
                                    value={title}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="contactFormEmail" className="sr-only">
                                    Hình ảnh
                                </label>
                                <input
                                    required
                                    type="text"
                                    name="img"
                                    placeholder="Url image (hơi cùi ạ :v)"
                                    id="contactFormEmail"
                                    className="form-control input-lg"
                                    value={img}
                                    onChange={this.handleChange}
                                />
                            </div>
                            {
                                this.state.description ? this.state.description.map((item, index) => {
                                    return (
                                        <div className="form-group form-content" key={index}>
                                            <label htmlFor="contactFormMessage" className="sr-only">Nội dung {index + 1}</label>
                                            <textarea
                                                required
                                                rows={3}
                                                name="content"
                                                className="form-control"
                                                placeholder="Content"
                                                id="contactFormMessage"
                                                value={item}
                                                onChange={(e) => this.handleChangeDesc(e, index)}
                                            />
                                            <button
                                                className="btn btn-warning btn-remove"
                                                onClick={() => this.handleRemoveClick(index)}
                                            >Xoá</button>
                                        </div>
                                    )
                                }) : ['']
                            }<button
                                className="btn btn-info mt-2 mb-3 btn-add-blog"
                                onClick={() => this.handleAddClick()}
                            >Thêm nội dung</button>
                            <button
                                className="btn btn-primary btn-lg btn-rb mr-3"
                                onClick={this.handleSubmit}
                            >
                                Thêm blog
                            </button>
                            <button
                                className="btn btn-outline-secondary btn-lg"
                                onClick={this.closeModal}
                            >Huỷ</button>
                        </div>
                    </Modal.Body>
                </>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.modal
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addBlog: (blog) => {
            dispatch(actions.fetchAPIAddBlog(blog))
        },
        editBlog: (blog) => {
            dispatch(actions.fetchAPIEditBlog(blog))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalView);
